import {useResources} from '@/di/di.root-container.hooks';

import cn from 'classnames';

import {HttpError, HttpErrorBackend} from '@specials/project-user';

import {FrontendError} from '@/services/ErrorService/FrontendError';

import s from './ErrorCode.module.css';

export interface ErrorCodeProps {
  errorCode?: string;
  requestId?: string;
  error: FrontendError | HttpError | unknown;
  className?: string;
}

export function ErrorCode({errorCode, error, requestId, className}: ErrorCodeProps): JSX.Element {
  const {
    content: {
      ErrorCodeMessage: {errorCodeTitleTemplate, identificatorText, defaultErrorCodeTitle},
    },
  } = useResources();

  const getErrorCodeTitle = (): string => {
    if (errorCode) {
      return errorCode;
    }

    if (HttpErrorBackend.isHttpErrorBackend(error)) {
      return error.response.httpCode.toString();
    }

    if (typeof error === 'object' && error !== null && 'name' in error) {
      return `${error.name}`;
    }

    return defaultErrorCodeTitle;
  };

  const idText = requestId ? identificatorText : '';

  return (
    <span className={cn(s.errorCode, className)}>
      {errorCodeTitleTemplate.replace('%errorCodeTitle%', getErrorCodeTitle())}
      {` ${idText} `}
    </span>
  );
}
